/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import cn from 'clsx';
import T from 'i18n-react';
import { Modal } from 'antd';
import get from 'lodash/get';
import HorizontalScroll from 'components/New/HorizontalScroll';
import SaveToModal from '../SaveToModal';
import SetDatesModal from '../SetDatesModal';
import ShareDocumentModal from '../ShareDocumentModal';
import RenameModal from '../RenameModal';
import EditTypeModal from '../EditTypeModal';
import MoveModal from '../MoveModal';
import SaveToAndSetData from '../SaveToAndSetData';
import SetDataModal from '../SetDataModal';
import { ITEMS, ITEM_TYPE, getModuleText, MODULE_TEXT } from './constants';
import classes from './FunctionBar.module.scss';

let actionCb = {};

const FunctionBar = ({
  className,
  onReset,
  selectedRows,
  displayItems,
  actions,
  typeOptions,
  noGap,
  module,
  metadataItems = {},
  settings,
  reloadTypeOptions,
  defaultSelectedFolders,
  onLoadFiles,
}) => {
  const [modal, contextHolder] = Modal.useModal();
  const [showSaveTo, setShowSaveTo] = useState(false);
  const [showSetDates, setShowSetDates] = useState(false);
  const [showSaveToSetData, setShowSaveToSetData] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [showRename, setShowRename] = useState(false);
  const [showEditType, setShowEditType] = useState(false);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [showSetData, setShowSetData] = useState(false);
  const selectedCount = selectedRows?.length || 0;
  const defaultSelectedDocument = selectedCount > 1 ? {} : selectedRows?.[0] || {};
  const CONFIRM_TYPE_MAPPING = getModuleText(selectedRows)?.[module] || {};
  const items = ITEMS.filter((obj) => displayItems.includes(obj.type)).map((obj) => {
    const isSelectItem = obj.type === ITEM_TYPE.SELECT;
    const isRenameItem = obj.type === ITEM_TYPE.RENAME;
    const isMoveItem = obj.type === ITEM_TYPE.MOVE;
    const tSettingDisableFunction = settings?.disables?.[obj.type];
    return {
      ...obj,
      id: obj.type,
      disabled:
        (isRenameItem && selectedRows?.length > 1) ||
        (isMoveItem && settings?.disabledMove) ||
        (!!tSettingDisableFunction && tSettingDisableFunction(obj, selectedRows)),
      label: (
        <>
          <span>
            {obj.label}
            {isSelectItem ? ` ${selectedCount}` : ''}
          </span>
        </>
      ),
      iconAction: isSelectItem
        ? () => {
            onReset();
          }
        : undefined,
    };
  });
  const handleConfirm = (tType, cb, loadingCb, unLoadingCb, isWarning) => {
    const confirmObj = CONFIRM_TYPE_MAPPING[tType];
    if (confirmObj) {
      const isItemColorWarning = settings?.colors?.[tType] === 'warning';
      const modalAction = isWarning || isItemColorWarning ? modal.warning : modal.confirm;
      modalAction({
        title: confirmObj?.title,
        icon: <></>,
        content: confirmObj?.description,
        onOk() {
          if (loadingCb) loadingCb();
          if (cb)
            cb(() => {
              if (unLoadingCb) unLoadingCb();
            });
        },
        okText: confirmObj?.submitText,
        onCancel() {},
        centered: true,
        cancelButtonProps: {
          className: classes.cancelBtn,
        },
        closable: true,
        className: classes.warningModal,
      });
    }
  };
  const handleAction = (tObj, loadingCb, unLoadingCb) => {
    actionCb[tObj.type] = {
      loadingCb,
      unLoadingCb,
    };
    switch (tObj.type) {
      case ITEM_TYPE.SAVE_TO:
        if (selectedRows?.length > 1 && selectedRows.filter((obj) => obj.documentList).length > 0) {
          handleConfirm(
            ITEM_TYPE.SAVE_TO,
            () => {
              setShowSaveTo(true);
            },
            () => {},
            () => {},
            true
          );
        } else {
          setShowSaveTo(true);
        }
        break;
      case ITEM_TYPE.SET_DATES:
        if (selectedRows?.length > 1 && selectedRows.filter((obj) => obj.documentList).length > 0) {
          handleConfirm(
            ITEM_TYPE.SET_DATES,
            () => {
              setShowSetDates(true);
            },
            () => {},
            () => {},
            true
          );
        } else {
          setShowSetDates(true);
        }
        break;
      case ITEM_TYPE.SAVE_TO_SET_DATA:
        if (selectedRows?.length > 1 && selectedRows.filter((obj) => obj.documentList).length > 0) {
          handleConfirm(
            ITEM_TYPE.SAVE_TO_SET_DATA,
            () => {
              setShowSaveToSetData(true);
            },
            () => {},
            () => {},
            true
          );
        } else {
          setShowSaveToSetData(true);
        }
        break;
      case ITEM_TYPE.SHARE:
        setShowShare(true);
        break;
      case ITEM_TYPE.MOVE:
        setShowMoveModal(true);
        break;
      case ITEM_TYPE.RENAME:
        setShowRename(true);
        break;
      case ITEM_TYPE.SET_DATA:
        if (selectedRows?.length > 1 && selectedRows.filter((obj) => obj.documentList).length > 0) {
          handleConfirm(
            ITEM_TYPE.SET_DATA,
            () => {
              setShowSetData(true);
            },
            () => {},
            () => {},
            true
          );
        } else {
          setShowSetData(true);
        }
        break;
      case ITEM_TYPE.EDIT_TYPE:
        if (selectedRows?.length > 1 && selectedRows.filter((obj) => obj.documentList).length > 0) {
          handleConfirm(
            ITEM_TYPE.EDIT_TYPE,
            () => {
              setShowEditType(true);
            },
            () => {},
            () => {},
            true
          );
        } else {
          setShowEditType(true);
        }
        break;
      case ITEM_TYPE.DOWNLOAD:
        const tDownLoadAction = actions?.[ITEM_TYPE.DOWNLOAD];
        if (tDownLoadAction) {
          if (loadingCb) loadingCb();
          tDownLoadAction(unLoadingCb);
        }
        break;
      case ITEM_TYPE.RESTORE:
        const tRestoreAction = actions?.[ITEM_TYPE.RESTORE];
        if (tRestoreAction) {
          if (loadingCb) loadingCb();
          tRestoreAction(unLoadingCb);
        }
        break;
      default:
        handleConfirm(tObj.type, actions?.[tObj.type], loadingCb, unLoadingCb);
        break;
    }
  };

  React.useEffect(() => {
    actionCb = {};
  }, []);

  return (
    <>
      <div className={cn(classes.wrapper, className)}>
        <HorizontalScroll
          items={items}
          onAction={(tObj, loadingCb, unLoadingCb) => {
            handleAction(tObj, loadingCb, unLoadingCb);
          }}
          box
          className={classes.fbElement}
          isAsync
          noGap={noGap}
        />
      </div>
      {showSaveToSetData && (
        <SaveToAndSetData
          open
          documents={selectedRows}
          onCancel={() => {
            setShowSaveToSetData(false);
          }}
          onSubmit={(values, form) => {
            setShowSaveToSetData(false);
            const tLoadingCb = actionCb[ITEM_TYPE.SAVE_TO_SET_DATA]?.loadingCb;
            const tUnLoadingCb = actionCb[ITEM_TYPE.SAVE_TO_SET_DATA]?.unLoadingCb;
            if (tLoadingCb) tLoadingCb();
            const tEditTypeAction = actions?.[ITEM_TYPE.SAVE_TO_SET_DATA];
            if (tEditTypeAction) {
              tEditTypeAction(values, form, () => {
                if (tUnLoadingCb) tUnLoadingCb();
              });
            }
          }}
          metadata={get(metadataItems, ITEM_TYPE.SAVE_TO_SET_DATA, {})}
        />
      )}
      {showSaveTo && (
        <SaveToModal
          open
          onClose={() => {
            setShowSaveTo(false);
            // setShowSaveToSetData(false);
          }}
          selectedRows={selectedRows}
          onSubmit={(tSelectedItems) => {
            setShowSaveTo(false);
            // setShowSaveToSetData(false);
            const tLoadingCb = actionCb[ITEM_TYPE.SAVE_TO]?.loadingCb;
            const tUnLoadingCb = actionCb[ITEM_TYPE.SAVE_TO]?.unLoadingCb;
            if (tLoadingCb) tLoadingCb();
            const tEditTypeAction = actions?.[ITEM_TYPE.SAVE_TO];
            if (tEditTypeAction) {
              tEditTypeAction(tSelectedItems, () => {
                if (tUnLoadingCb) tUnLoadingCb();
              });
            }
          }}
          defaultSelectedDocument={defaultSelectedDocument}
          // hasSetData={showSaveToSetData}
        />
      )}
      {showSetDates && (
        <SetDatesModal
          open
          onClose={() => {
            setShowSetDates(false);
          }}
          onSubmit={(values) => {
            setShowSetDates(false);
            const tLoadingCb = actionCb[ITEM_TYPE.SET_DATES]?.loadingCb;
            const tUnLoadingCb = actionCb[ITEM_TYPE.SET_DATES]?.unLoadingCb;
            if (tLoadingCb) tLoadingCb();
            const tSetDatesAction = actions?.[ITEM_TYPE.SET_DATES];
            if (tSetDatesAction) {
              tSetDatesAction(values, () => {
                if (tUnLoadingCb) tUnLoadingCb();
              });
            }
          }}
          defaultSelectedDocument={defaultSelectedDocument}
        />
      )}
      {showShare && (
        <ShareDocumentModal
          open
          onClose={() => {
            setShowShare(false);
          }}
          selectedRecords={selectedRows}
          isProductProfile={module === MODULE_TEXT.PRODUCT_PROFILE}
          onSubmit={(val) => {
            setShowShare(false);
            const tLoadingCb = actionCb[ITEM_TYPE.SHARE]?.loadingCb;
            const tUnLoadingCb = actionCb[ITEM_TYPE.SHARE]?.unLoadingCb;
            if (tLoadingCb) tLoadingCb();
            const tAction = actions?.[ITEM_TYPE.SHARE];
            if (tAction)
              tAction(val, () => {
                if (tUnLoadingCb) tUnLoadingCb();
              });
          }}
          onEmail={(val) => {
            setShowShare(false);
            const tLoadingCb = actionCb[ITEM_TYPE.SHARE]?.loadingCb;
            const tUnLoadingCb = actionCb[ITEM_TYPE.SHARE]?.unLoadingCb;
            if (tLoadingCb) tLoadingCb();
            const tAction = actions?.[ITEM_TYPE.SHARE_EMAIL];
            if (tAction)
              tAction(val, () => {
                if (tUnLoadingCb) tUnLoadingCb();
              });
          }}
        />
      )}
      {showRename && (
        <RenameModal
          open
          onClose={() => {
            setShowRename(false);
          }}
          onSubmit={(val) => {
            setShowRename(false);
            const tLoadingCb = actionCb[ITEM_TYPE.RENAME]?.loadingCb;
            const tUnLoadingCb = actionCb[ITEM_TYPE.RENAME]?.unLoadingCb;
            if (tLoadingCb) tLoadingCb();
            const tRenameAction = actions?.[ITEM_TYPE.RENAME];
            if (tRenameAction)
              tRenameAction(val, () => {
                if (tUnLoadingCb) tUnLoadingCb();
              });
          }}
          defaultSelectedDocument={defaultSelectedDocument}
        />
      )}
      {showEditType && (
        <EditTypeModal
          open
          onClose={() => {
            setShowEditType(false);
          }}
          typeOptions={typeOptions}
          defaultSelectedDocument={defaultSelectedDocument}
          onSubmit={(val) => {
            setShowEditType(false);
            const tLoadingCb = actionCb[ITEM_TYPE.EDIT_TYPE]?.loadingCb;
            const tUnLoadingCb = actionCb[ITEM_TYPE.EDIT_TYPE]?.unLoadingCb;
            if (tLoadingCb) tLoadingCb();
            const tEditTypeAction = actions?.[ITEM_TYPE.EDIT_TYPE];
            if (tEditTypeAction) {
              tEditTypeAction(val, () => {
                if (tUnLoadingCb) tUnLoadingCb();
              });
            }
          }}
          reloadData={reloadTypeOptions}
        />
      )}
      {!!showMoveModal && (
        <MoveModal
          open
          onSubmit={(tFolderId) => {
            setShowMoveModal(false);
            const tLoadingCb = actionCb[ITEM_TYPE.MOVE]?.loadingCb;
            const tUnLoadingCb = actionCb[ITEM_TYPE.MOVE]?.unLoadingCb;
            if (tLoadingCb) tLoadingCb();
            const tMoveAction = actions?.[ITEM_TYPE.MOVE];
            if (tMoveAction) {
              tMoveAction(tFolderId, () => {
                if (tUnLoadingCb) tUnLoadingCb();
              });
            }
          }}
          onClose={() => {
            setShowMoveModal(false);
          }}
          items={selectedRows}
          defaultSelectedFolders={defaultSelectedFolders}
          onLoadFiles={onLoadFiles}
        />
      )}
      {!!showSetData && (
        <SetDataModal
          open
          documents={selectedRows}
          onCancel={() => {
            setShowSetData(false);
          }}
          onSubmit={(values, form) => {
            setShowSetData(false);
            const tLoadingCb = actionCb[ITEM_TYPE.SET_DATA]?.loadingCb;
            const tUnLoadingCb = actionCb[ITEM_TYPE.SET_DATA]?.unLoadingCb;
            if (tLoadingCb) tLoadingCb();
            const tEditTypeAction = actions?.[ITEM_TYPE.SET_DATA];
            if (tEditTypeAction) {
              tEditTypeAction(values, form, () => {
                if (tUnLoadingCb) tUnLoadingCb();
              });
            }
          }}
          metadata={get(metadataItems, ITEM_TYPE.SET_DATA, {})}
        />
      )}
      {contextHolder}
    </>
  );
};

export default FunctionBar;
